import React, {useState} from "react";
import styled from "@emotion/styled";
import mediaqueries from "@styles/media";
import AreaMenu from "./AreaMenu";
import BButton from "@components/BButton";

const NavigationHeaderMenuMobile: React.FC<{}> = () => {
  const [isBurgerMenuOpen, setIsBurgerMenuOpen] = useState(false);
  function openBurgerMenu () {
    setIsBurgerMenuOpen(!isBurgerMenuOpen);
  }

  return (
    <NavigationHeaderMenuMobileContainer>
      <BurgerMenu>
        <img onClick={openBurgerMenu} src="https://statics.get-base.com/icons/icon_burger.svg" alt="menu"/>
        {isBurgerMenuOpen && (
          <BurgerMenuPopup >
              <>
              <AreaMenu />
              <BurgerMenuPopupLink href="/blog/">BLOG</BurgerMenuPopupLink>
              <BurgerMenuPopupLink href="science">SCIENCE</BurgerMenuPopupLink>
              <BButton href="/quiz" text="TAKE QUIZ" arrow={true} />
              </>
          </BurgerMenuPopup>
        )}
      </BurgerMenu>
    </NavigationHeaderMenuMobileContainer>
  );
};

export default NavigationHeaderMenuMobile;

const NavigationHeaderMenuMobileContainer = styled.div`
  display: none;
  ${mediaqueries.tablet`
    display: block;
  `}
`;

const BurgerMenu = styled.div`
  padding: 0 12px;
`;

const BurgerMenuPopup = styled.div`
  position: absolute;
  top: 46px;
  right: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  padding: 0 24px 16px 24px;
`;

const BurgerMenuPopupLink = styled.a`
  color: #000000;
  padding: 8px;
`;
